import React from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from '../../services/user.service';
import { useForm } from "react-hook-form";

const PhoneModal = (props) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { phone: props.user.phone || "", userId: props.user.id },
  });

  const onSubmit = async (data) => {
    if (props.selfService) {
      await UserService.updateMyPhone(data.phone);
    } else {
      await UserService.updatePhone(data);
    }
    props.closePhoneModal(false);
  }

  const phoneModalClose = () => {
    props.closePhoneModal(false);
  }

  return (
    <Modal show={props.show} onHide={phoneModalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Phone Number<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <input type="tel" {...register("phone", { maxLength: 45 })} /><br/>
                {errors.phone && <div className="error" >Phone Number can't be more than 45 characters</div>}
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={phoneModalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
                  Update Phone
                </Button>
              </Modal.Footer>
            </Form>


    </Modal.Body>
    </Modal>
  );
};

export default PhoneModal;
